<template>
	<BaseCmsPage @load="onPageLoad">
		<CmsCheckoutWrapper>
			<WebshopCheckout>
				<ClientOnly>
					<div class="thank-you">
						<BaseCmsLabel code="order_cancel_title" tag="h1" class="thank-you-title cancel" />

						<BaseCmsLabel code="cancel_order_description" tag="div" class="wc-error-order" />
						<div class="wc-error-order special">
							<BaseCmsLabel code="order_id" />:&nbsp;
							<strong>
								<template v-if="additionalPaymentRoute == 1">{{ additionalPayment.cart?.order_id }}</template>
								<template v-else-if="orderData && orderData.cart">{{ orderData.cart?.order_id }}</template>
							</strong>
						</div>
						<BaseCmsLabel code="thank_you_support" tag="div" class="thank-you-support" />

						<div class="thank-you-continue">
							<NuxtLink to="/" class="thank-you-continue-btn"><BaseCmsLabel code="thank_you_continue_shopping" /></NuxtLink>
						</div>
					</div>
					<template #fallback>
						<BaseThemeUiLoading />
					</template>
				</ClientOnly>
			</WebshopCheckout>
		</CmsCheckoutWrapper>
	</BaseCmsPage>
</template>

<script setup>
	const endpoints = useEndpoints();
	const { orderSuccess, additionalPaymentRoute, additionalPayment, orderData } = useCheckout();

	onMounted(() => {
		const url = window.location.href;
		const searchParams = new URL(url).searchParams;

		if(additionalPaymentRoute.value == 0 && searchParams.get('webshopadditionalpayment')) {
			additionalPaymentRoute.value = 1;
			let urlId = searchParams.get('order_identificator');
			urlId = urlId.replace("|", '-').replace("|webshoporder", '');

			const webshopOrderId = endpoints.get('_get_hapi_webshop_additionalpayment');
			const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", urlId);

			async function fetchOrderData() {
				await useApi(webshopOrder, {method: 'GET'})
				.then(async (res) => {
					additionalPayment.value = res.data;
				});
			}

			fetchOrderData();
		}

		if(orderSuccess.value == 0 && additionalPaymentRoute.value == 0 && searchParams.get('order_identificator')) {
			let urlId = searchParams.get('order_identificator');
			urlId = urlId.replace("|", '-').replace("|webshoporder", '');

			const webshopOrderId = endpoints.get('_get_hapi_webshop_order');
			const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", urlId);

			async function fetchOrderData() {
				await useApi(webshopOrder)
				.then(async (res) => {
					orderData.value = res.data;
				});
			}

			fetchOrderData();
		}

		orderSuccess.value = 0;
	});

	//gtm
	const gtm = useGtmBB();

	function onPageLoad(data) {
		if(!data) return;
		gtm.pageView({
			url: data?.url || '',
			title: data?.title || '',
		});
	}
</script>

<style lang="less">
	.thank-you-title.cancel:before{
		display: flex; align-items: center; justify-content: center; width: 26px; height: 26px; border: 2px solid @red2; border-radius: 100%; .icon-x(); font: 17px/1 @fonti; text-indent: 1px; color: @red2;

		@media (max-width: @m){width: 24px; height: 24px; font-size: 15px; text-indent: 0;}
	}
	.wc-error-order{
		display: flex; align-items: center; margin: 5px 0 20px; padding: 15px 20px; border: 1px solid @borderColor;
		&.special{margin-top: -21px;}

		@media (max-width: @m){
			margin-bottom: 15px; padding: 15px; font-size: 15px; line-height: 1.4;
			&.special{margin-top: -16px;}
		}
	}
</style>
